import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: '📘',
  number: 'Tomo 1',
  title: 'Fundamentos de la metodología de la investigación',
  subtitle: 'La base que tus alumnos necesitan para entender todo lo demás',
  problem: 'El primer contacto con la metodología puede ser el más transformador o el más aburrido. Este tomo convierte un tema técnico en algo comprensible y relevante para tus alumnos desde el primer día.',
  bullets: ['Qué es la metodología de la investigación y para qué sirve', 'Cuáles son sus elementos principales', 'Cómo se organiza una investigación correctamente', 'Material explicado de forma clara para que tus alumnos lo entiendan sin dificultad'],
  result: 'Tus alumnos entienden la investigación como un proceso lógico y ordenado, no como un conjunto de términos imposibles de memorizar.'
}, {
  icon: '📗',
  number: 'Tomo 2',
  title: 'Planteamiento del problema y formulación de objetivos',
  subtitle: 'El punto de partida de toda investigación bien estructurada',
  problem: 'Este es uno de los puntos donde más se traban los alumnos. Este tomo te da el material listo para que puedan aprenderlo con claridad.',
  bullets: ['Cómo identificar y delimitar un problema de investigación', 'Formulación de preguntas de investigación', 'Construcción del objetivo general y los objetivos específicos', 'Justificación del estudio'],
  result: 'Tus alumnos aprenden a definir con claridad qué van a investigar, por qué y para qué, sin dar vueltas en círculos.'
}, {
  icon: '📙',
  number: 'Tomo 3',
  title: 'Marco teórico y revisión de literatura',
  subtitle: 'Cómo enseñar a construir una base sólida de investigación',
  problem: 'El marco teórico suele ser el apartado que más confunde a los alumnos. Este tomo te da el material para explicarlo de forma ordenada y comprensible.',
  bullets: ['Antecedentes y cómo buscarlos correctamente', 'Bases teóricas y conceptos clave', 'Organización lógica de la información', 'Cómo darle coherencia académica al trabajo'],
  result: 'Tus alumnos aprenden a respaldar su investigación con fundamentos sólidos y bien organizados.'
}, {
  icon: '📕',
  number: 'Tomo 4',
  title: 'Tipos, enfoques y diseños de investigación',
  subtitle: 'El módulo que más dudas genera y mejor resuelto está en este pack',
  problem: 'Este es el núcleo más complejo de la metodología. Aquí tus alumnos aprenden a distinguir los enfoques y elegir el correcto para su investigación.',
  bullets: ['Investigación cuantitativa, cualitativa y mixta', 'Investigación exploratoria, descriptiva, correlacional y explicativa', 'Diseños experimentales, cuasi experimentales y no experimentales', 'Diseños transversales y longitudinales'],
  result: 'Tus alumnos dejan de confundir conceptos y aprenden a elegir el enfoque correcto según su tema de investigación.',
  popular: true
}, {
  icon: '📓',
  number: 'Tomo 5',
  title: 'Población, muestra, técnicas e instrumentos',
  subtitle: 'Enseña a recolectar información de forma correcta',
  problem: 'Uno de los puntos más prácticos de la metodología. Este tomo le da a tus alumnos las herramientas para saber cómo obtener datos válidos y confiables.',
  bullets: ['Diferencia entre población y muestra', 'Tipos de muestreo y cuándo usar cada uno', 'Técnicas de recolección de datos', 'Instrumentos de investigación y su aplicación'],
  result: 'Tus alumnos comprenden cómo obtener información útil y metodológicamente correcta para sus investigaciones.'
}, {
  icon: '📔',
  number: 'Tomo 6',
  title: 'Análisis, interpretación y presentación de resultados',
  subtitle: 'El cierre que completa el proceso investigativo',
  problem: 'Muchos alumnos llegan al final de su investigación sin saber cómo interpretar lo que encontraron. Este tomo les enseña a cerrar el proceso con claridad.',
  bullets: ['Organización y análisis de los datos recolectados', 'Interpretación correcta de los resultados', 'Relación entre resultados, objetivos e hipótesis', 'Construcción de conclusiones sólidas y coherentes'],
  result: 'Tus alumnos cierran su investigación con claridad, coherencia y seguridad metodológica.'
}];
export function TomosSection() {
  return <section className="py-24 px-4 bg-black" data-id="element-280" data-mp="4zyu5g6hlbg6">
      <div className="max-w-6xl mx-auto" data-id="element-281" data-mp="510fcdh7vebm">
        <div className="text-center mb-16" data-id="element-282" data-mp="92bzw4l8h9cy">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4" data-id="element-283" data-mp="91ak5mt9vyow">
            📘 Los 6 tomos del Mega Pack
          </h2>
          <p className="text-xl text-gold-light" data-id="element-284" data-mp="izzv0vmr4ivn">
            Material completo para el aula
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-285" data-mp="t4gahnwbjxyx">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className={`bg-dark-card rounded-2xl border ${tomo.popular ? 'border-gold shadow-[0_0_30px_rgba(212,175,55,0.15)]' : 'border-dark-border'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-286" data-mp="o53r5d4np913" data-mpi={index}>
              {tomo.popular && <div className="absolute top-6 right-[-35px] bg-gold text-black font-bold text-xs py-1 px-10 rotate-45 shadow-lg" data-id="element-287" data-mp="1ul5xrm6scbov">
                  EL MÁS POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-288" data-mp="3k1rr5qmhme9b">
                <span className="text-4xl" data-id="element-289" data-mp="3k4dzvtl46zt4">{tomo.icon}</span>
                <div data-id="element-290" data-mp="3p0l51k5os7a0">
                  <div className="text-gold font-bold text-sm uppercase tracking-wider" data-id="element-291" data-mp="3p37a9d53uap2">
                    {tomo.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1" data-id="element-292" data-mp="3fajhqul5qsw5">
                    {tomo.title}
                  </h3>
                </div>
              </div>

              <p className="text-white font-medium mb-6 italic border-l-2 border-gold/50 pl-4" data-id="element-293" data-mp="36ad8xm0emh3b">
                {tomo.subtitle}
              </p>

              <div className="mb-6" data-id="element-294" data-mp="2rex7ux1epkxf">
                <h4 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-295" data-mp="2wcgykwfajq69">
                  ¿Qué resuelve en el aula?
                </h4>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-296" data-mp="pmiu8a5wb2mt">
                  {tomo.problem}
                </p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-297" data-mp="2f34n8dhor36q">
                {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-298" data-mp="2a4bfl1p2y6eh" data-mpi={i}>
                    <CheckCircle2 size={18} className="text-gold shrink-0 mt-0.5" data-id="element-299" data-mp="2a1ytcccah9vm" />
                    <span className="text-gray-200 text-sm" data-id="element-300" data-mp="2k1xydz9i2i3q">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-gold/10 border border-gold/30 rounded-xl p-4 mt-auto" data-id="element-301" data-mp="2xrt2ojxeggb4">
                <span className="text-gold font-bold block mb-1" data-id="element-302" data-mp="2trhjzcolkq2a">
                  Resultado:
                </span>
                <p className="text-white text-sm" data-id="element-303" data-mp="37r0ozwm43lad">{tomo.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}